import { toast } from "@/helpers/toast"

const TextNoty = (successfulText, type = "error") => {
  return toast({ text: successfulText, type });
};

export default TextNoty;
